/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Form, Radio, Button, Input, InputNumber, Select,
} from 'antd';
// import { Select } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from 'react';
import classes from './index.module.css';
import ContentPanel from '../components/ContentPanel';
import Buttons from '../components/Buttons';
import {
  TITLE, DESC, ELIGIBLE_PRODUCTS_LIST, CODITION_MATCH_TYPE, CONDITION_SELECT, CONDITION_MAP,
} from './const';

const CONDITION_FOR_TAG_TIPS = 'You can add the "ra-include" tag to specific products in your Shopify admin to make Return Assurance available for them.';

export default function EligibleProducts({ options }) {
  const form = Form.useFormInstance();
  const [conditionOptions, setConditionOptions] = useState(CONDITION_SELECT);
  const [errorMessage, setErrorMessage] = useState(false);

  // 设置condition下拉选项是否可选
  const handleSetOptions = () => {
    const names = form.getFieldValue('names');
    const types = names.map((name) => name.condition_type);
    setConditionOptions(conditionOptions.map((item) => ({ ...item, disabled: types.includes(item.value) })));
  };
  return (
    <ContentPanel title={TITLE.first} desc={DESC.first} step={1}>
      <Form.Item
        noStyle
        className={classes.radio_group}
        name="eligible_products"
      >
        <Radio.Group>
          {ELIGIBLE_PRODUCTS_LIST.map(({
            value, label, recommended, desc,
          }) => (
            <div className={classes.radio} key={value}>
              <Radio value={value}>
                <div className={classes.radio_title}>
                  {label}
                  {recommended
                    && <span className={classes.radio_recommended}>{recommended}</span>}
                </div>
              </Radio>
              <div className={classes.radio_desc}>{desc}</div>

            </div>

          ))}
        </Radio.Group>
      </Form.Item>
      <Form.Item shouldUpdate noStyle>
        {
          ({ getFieldValue }) => {
            if (getFieldValue('eligible_products') === '2') {
              return (
                <div className={classes.conditions}>
                  <div className={classes.conditions_title}>CONDITIONS</div>
                  <div className={classes.conditions_match}>
                    Products must match:  &nbsp;
                    <Form.Item
                      name="match_type"
                      shouldUpdate
                      className={classes.match_type}
                      labelCol={{ span: 16 }}
                      style={{ display: 'flex', flexDirection: 'row' }}
                      noStyle
                    >
                      <Radio.Group>
                        {CODITION_MATCH_TYPE.map(({
                          value, label,
                        }) => (
                          <Radio value={value} key={value}>
                            <div className={classes.radio_title}>
                              {label}
                            </div>
                          </Radio>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  <Form.List
                    name="names"
                  // rules={[
                  //   {
                  //     validator: async (_, names) => {
                  //       if (!names || names.length < 2) {
                  //         return Promise.reject(new Error('At least 2 passengers'));
                  //       }
                  //     },
                  //   },
                  // ]}
                  >
                    {(fields, { add, remove }, { errors }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => {
                          const field = getFieldValue('names')[name];
                          return (
                            <Form.Item
                              label={`Condition ${index + 1}`}
                              key={key}
                            >
                              <div className={classes.condition_item}>
                                {/* {console.log(name, form.getFieldsValue(true), fields, 'name')} */}
                                <Form.Item
                                  {...restField}
                                  validateTrigger={['onChange', 'onBlur']}
                                  noStyle
                                  name={[name, 'condition_type']}
                                  style={{ marginRight: '10px' }}
                                >
                                  <Select
                                    options={conditionOptions}
                                    style={{ width: 170, marginRight: 10 }}
                                    onChange={() => handleSetOptions(getFieldValue('names'))}
                                  />
                                </Form.Item>
                                <Select
                                  disabled
                                  value={CONDITION_MAP[field.condition_type]}
                                  style={{ width: 90, marginRight: 10 }}
                                />
                                {field.condition_type === '1'
                                  ? (
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'nameId']}
                                      noStyle
                                    >
                                      {/* <Select
                                        options={options}
                                        placeholder="Select..."
                                        style={{ width: 200 }}
                                        mode="multiple"
                                        showArrow
                                      // dropdownRender={(item) => {
                                      //   console.log(item, 'item');
                                      //   return item;
                                      // }}
                                      /> */}
                                      <Select
                                        mode="multiple"
                                        options={options}
                                        placeholder="Select..."
                                        style={{ width: 320, marginRight: 10 }}
                                        onChange={() => handleSetOptions(getFieldValue('names'))}
                                        className="multiple_select"
                                        // menuItemSelectedIcon={<Checkbox />}
                                        // eslint-disable-next-line react/no-unstable-nested-components
                                        tagRender={({ label }) => <span className={classes.multiple_tag_render}>{label}</span>}
                                      // dropdownRender={(node, props) => {
                                      //   console.log(node, props, 'node');
                                      //   return (
                                      //     <div>
                                      //       <Checkbox />
                                      //       {' '}
                                      //       <span></span>
                                      //     </div>
                                      //   );
                                      //   // return node;
                                      // }}
                                      >

                                      </Select>
                                    </Form.Item>
                                  )
                                  : field.condition_type === '2' ? (
                                    <Form.Item
                                      name={[name, 'discount']}
                                      noStyle
                                      rules={[
                                        {
                                          validator(_, value) {
                                            if (value && (value < 0 || value > 100)) {
                                              setErrorMessage(true);
                                              return Promise.reject(new Error('Value must be between 0 and 100'));
                                            }
                                            setErrorMessage(false);
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        addonAfter="%"
                                        style={{ width: '320px', marginRight: 10 }}
                                      />
                                    </Form.Item>
                                  ) : (
                                    <Input
                                      placeholder="ra-include"
                                      disabled
                                      style={{ width: 320, marginRight: 10, color: '#fff' }}
                                    />

                                  )}
                                {
                                  fields.length > 1 ? (
                                    <span
                                      onClick={() => {
                                        remove(name);
                                        handleSetOptions(getFieldValue('names'));
                                      }}
                                      style={{ display: 'flex', color: '#F44336', cursor: 'pointer' }}
                                    >
                                      <DeleteOutlineIcon />
                                    </span>
                                  ) : null
                                }
                              </div>
                              {field.condition_type === '3'
                                && <div className={classes.tag_include_tips}>{CONDITION_FOR_TAG_TIPS}</div>}
                            </Form.Item>
                          );
                        })}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              // 增加一条数据时，设置condition_type默认值为下拉选项中可选中的项
                              const names = form.getFieldValue('names');
                              names.pop();
                              const typeIsAbled = conditionOptions.filter((item) => !item.disabled) || [];
                              form.setFieldsValue({ names: [...names, { condition_type: typeIsAbled[0]?.value }] });
                              handleSetOptions();
                            }}
                            style={{
                              width: '150px',
                            }}
                            disabled={fields.length > 2}
                          >
                            + Add condition
                          </Button>
                          <Form.ErrorList errors={errors} />
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </div>
              );
            }
          }
        }
      </Form.Item>
      <Form.Item
        shouldUpdate
      >
        {({ getFieldValue }) => {
          const names = getFieldValue('names');
          let flag = false;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < names.length; i++) {
            const { condition_type, nameId, discount } = names[i];
            switch (condition_type) {
              case '1': flag = !nameId?.length; break;
              case '2': flag = !discount; break;
              default: flag = false;
            }
            if (flag) {
              break;
            }
          }
          const isDisabled = (getFieldValue('eligible_products') === '2' && flag) || errorMessage;
          return (
            <Buttons
              backUrl="../intro"
              nextUrl="../widget-status"
              isDisabled={isDisabled}
            />
          );
        }}

      </Form.Item>
    </ContentPanel>

  );
}
